import { env } from "@/services/env.service";
import type { AppDispatch } from "@/store/store";
import { createTicketRequest } from "../ticketApi";

import {
  addQueueItemThunk,
  processQueueThunk,
} from "../ticketQueue/ticketQueueOperations";
import { Ticket } from "../ticketSharedTypes";
import { ticketListActions } from "../ticketList/ticketListSlice";

export const createNewTicketThunk = (ticketBody: TicketFormBody) => {
  return async (dispatch: AppDispatch) => {
    if (env.FF_OFFLINE_MODE) {
      // send ticket to queue
      await dispatch(addQueueItemThunk({ data: ticketBody }));
      await dispatch(processQueueThunk());
    } else {
      // old approach without queue
      const response = await createTicketRequest(ticketBody);
      dispatch(ticketListActions.createTicket(response.data));
      return response;
    }
  };
};

export interface AttachmentUpload {
  id: string;
  name: string;
  contentBase64: string;
  mimeType: string;
}

export type TicketFormBody = Pick<
  Ticket,
  | "accessibleByPersonIds"
  | "accessibleByTypes"
  | "anonymous"
  | "attachments"
  | "body"
  | "estateId"
  | "livingUnitIds"
  | "messagesEnabled"
  | "publishingMode"
  | "serviceType"
  | "subject"
>;
